import React from "react";
import {NavLink} from "react-router-dom";

const classnames = require("classnames");

class MenuItem extends React.Component {
    constructor(props, context) {

        super(props, context);
        this.state = {};
    }

    render() {
        if (this.props.hideIf === true) return null;
        if (this.props.showIf === false) return null;
        const {style, className} = this.props;
        const listItemStyle = classnames("navbar-responsive__list-item");

        if (this.props.external) {
            return (
                <li className={listItemStyle} onClick={this.props.onClick}>
                    <a target="_blank" rel="noopener noreferrer" href={this.props.to} className={className}
                       style={style || null}>
                        {this.props.children}
                    </a>
                </li>
            );
        }

        return (
            <li className={listItemStyle} onClick={this.props.onClick}>
                <NavLink to={this.props.to} activeClassName="active" className={className} style={style || null}>
                    {this.props.children}
                </NavLink>
            </li>
        );
    }
}

export default MenuItem;
